<template>
  <div>
    <header class="header">
      <h1 class="title">{{$t('register.header.title')}}</h1>
      <h2 class="subtitle">
        {{$t('global.orConjunction')}} <router-link :to="'/'">{{$t('global.login')}}</router-link>
      </h2>
    </header>

    <form @submit.prevent="next" novalidate>
      <fieldset v-if="step === 'data'" class="form">
        <p
          v-if="error.code && error.code != 409 && error.code != 412"
          class="help is-danger"
        >
          {{ error.message }}
        </p>
        <div class="change-city control has-icons-left">
          <div class="select is-primary">
            <select
              v-model="$root.app.city"
              @change="changeCity"
              :placeholder="$t('global.form.city.placeholder')"
              style="color: white"
            >
              <option
                v-for="option in cityOptions"
                v-bind:key="option.code"
                v-bind:value="option.code"
              >
                {{ option.city }} - {{ option.uf }}
              </option>
            </select>
          </div>
          <div class="icon is-small is-left is-pin"></div>
        </div>
        <zul-input
          type="text"
          v-model="user.name"
          name="name"
          key="user-input"
          icon="buddy"
          v-validate="'required|alpha_spaces'"
          :label="$t('global.form.name.title')"
        ></zul-input>
        <zul-input
          type="email"
          v-model="user.email"
          name="email"
          key="email-input"
          icon="email"
          v-validate="'required|email'"
          :label="$t('global.form.email.title')"
        ></zul-input>
        <p v-if="error.code === 409" class="help is-danger">
          E-mail já cadastrado
        </p>
        <zul-input
          type="text"
          v-model="user.document"
          name="document"
          key="document-input"
          icon="document"
          v-validate="'required|document'"
          :label="$t('global.form.document.title')"
          :mask="documentMask()"
        ></zul-input>
        <p v-if="error.code === 412" class="help is-danger">
          {{$t('global.registerError.412')}}
        </p>
        <zul-input
          type="text"
          v-if="!user.document || user.document.length < 15"
          v-model="user.birthdate"
          name="birthdate"
          key="birthdate-input"
          icon="gift"
          v-validate="'required|date_format:dd/MM/yyyy'"
          :label="$t('global.form.birthdate.title')"
          :mask="'##/##/####'"
        ></zul-input>
      </fieldset>

      <fieldset v-if="step === 'carplate'" class="form">
        <!--p v-if="error.code && error.code != 409 && error.code != 412" class="help is-danger">{{ error.message }}</p-->
        <zul-input
          :uppercase="true"
          type="text"
          v-model="user.vPlate"
          name="plate"
          v-validate="{ required: true, regex: /^[a-zA-Z]{3}-[0-9]{4}$/ }"
          :mask="'AAA-####'"
          :label="$t('global.form.registrationPlate.title')"
        ></zul-input>
        <!--p v-if="error.code === 412" class="help is-danger">Veículo já cadastrado</p-->
        <zul-input
          type="text"
          v-model="user.vAlias"
          name="alias"
          v-validate="'required'"
          :label="$t('global.form.model.title')"
        ></zul-input>
      </fieldset>

      <fieldset v-if="step === 'password'" class="form">
        <zul-input
          type="password"
          v-model="user.password"
          name="password"
          key="password-input"
          icon="lock"
          v-validate="{
            required: true,
            regex: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,15}$/,
          }"
          ref="password"
          :label="$t('global.form.password.title')"
          maxlength="15"
        ></zul-input>
        <zul-input
          type="password"
          v-model="user.confirm"
          name="confirm"
          key="confirm-input"
          icon="lock"
          v-validate="'confirmed:password'"
          :label="$t('global.form.confirmPassword.title')"
        ></zul-input>

        <p class="verify-password-title">{{$t('global.veriyPassword.title')}}</p>
        <ul class="verify-password">
          <li :class="{ 'is-valid': passwordHasAlpha }">{{$t('global.veriyPassword.passwordHasAlpha')}}</li>
          <li :class="{ 'is-valid': passwordHasNumber }">{{$t('global.veriyPassword.passwordHasNumber')}}</li>
          <li
            :class="{ 'is-valid': user.password && user.password.length >= 6 }"
          >
            {{$t('global.veriyPassword.passwordLength', ['6'])}}
          </li>
        </ul>
      </fieldset>

      <div class="buttons">
        <button ref="button" class="button is-primary is-large">
          {{$t('global.continue') | capitalize }}
        </button>
      </div>
    </form>

    <zul-modal
      ref="modal"
      class="is-large"
      :title="$t('global.termsOfUse')"
      :simplebar="true"
      :primary="$t('global.readAndAgree')"
      @primary="confirm"
    >
      <div v-html="terms"></div>
    </zul-modal>
    <OTPValidationModal
      ref="otpValidation"
      :maskedPhoneNumber="maskedPhoneNumber"
    ></OTPValidationModal>
  </div>
</template>
<script>
import OTPValidationModal from "../../modals/OTPValidation.vue";

export default {
  name: "Register",
  props: {},
  components: {
    OTPValidationModal,
  },
  data() {
    return {
      step: "data",
      user: {},
      error: {},
      terms: null,
      cityOptions: [
        { code: "AME", uf: "SP", city: "Americana" },
        { code: "ARA", uf: "SP", city: "Araraquara" },
        { code: "BHZ", uf: "MG", city: "Belo Horizonte" },
        { code: "CJZ", uf: "PB", city: "Cajazeiras" },
        { code: "CWB", uf: "PR", city: "Curitiba" },
        { code: "FTZ", uf: "CE", city: "Fortaleza" },
        { code: "ITA", uf: "SP", city: "Itatiba" },
        { code: "JAC", uf: "SP", city: "Jacareí" },
        { code: "JDN", uf: "CE", city: "Juazeiro do Norte" },
        { code: "JZF", uf: "PB", city: "Juiz de Fora" },
        { code: "LIM", uf: "SP", city: "Limeira" },
        { code: "MOG", uf: "SP", city: "Mogi das Cruzes" },
        { code: "MON", uf: "SP", city: "Mongaguá" },
        { code: "RIC", uf: "SP", city: "Rio Claro" },
        { code: "SGR", uf: "PE", city: "Salgueiro" },
        { code: "SSA", uf: "BA", city: "Salvador" },
        { code: "SBO", uf: "SP", city: "Santa Bárbara D'Oeste" },
        { code: "STA", uf: "SP", city: "Santo André" },
        { code: "SBC", uf: "SP", city: "São Bernardo do Campo" },
        { code: "SCA", uf: "SP", city: "São Carlos" },
        { code: "SBV", uf: "SP", city: "São João da Boa Vista" },
        { code: "SAO", uf: "SP", city: "São Paulo" },
        { code: "TAU", uf: "SP", city: "Taubaté" }
      ],
      maskedPhoneNumber: "",
    };
  },
  computed: {
    passwordHasAlpha() {
      return (
        this.user.password && /^(?=.*[a-zA-Z]).+$/.test(this.user.password)
      );
    },
    passwordHasNumber() {
      return this.user.password && /^(?=.*\d).+$/.test(this.user.password);
    },
  },
  created() {
    this.$auth.watch.authenticated = false;
    this.$auth.watch.loaded = false;
    this.$auth.user({});
  },
  methods: {
    changeCity($e) {
      this.$router.push("/" + $e.currentTarget.value.toLowerCase());
    },
    next() {
      this.error = {};

      this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          if (
            (this.app.city === "SSA" && this.step === "carplate") ||
            (this.app.city !== "SSA" && this.step === "data")
          ) {
            this.step = "password";
            this.$refs.button.textContent = this.$t('global.register2');
          } else if (this.app.city === "SSA" && this.step === "data") {
            this.step = "carplate";
          } else if (this.step === "password") {
            this.$refs.button.classList.add("is-loading");

            this.$http.get("terms").then((res) => {
              this.$refs.button.classList.remove("is-loading");

              this.terms = res.data.text;
              this.$refs.modal.open();
            });
          }
        }
      });
    },

    confirm() {
      delete this.user.confirm;
      this.user.acceptTermsOfUse = true;

      // user backup
      const userData = {
        name: this.user.name,
        email: this.user.email,
        document: this.user.document,
        birthdate: this.user.birthdate,
      };

      // disable modal button
      this.$refs.modal.startLoading();

      //  remove mask
      this.user.document = this.user.document.replace(/[./-]/g, "");

      // fix date format
      if (this.user.birthdate) {
        const date = this.user.birthdate.split("/");
        this.user.birthdate = `${date[2]}-${date[1]}-${date[0]}`;
      }

      if (this.app.city === "SSA") {
        this.user.vehicles = [];
        this.user.vehicles.push({
          type: "CAR",
          alias: this.user.vAlias,
          registrationPlate: this.user.vPlate,
        });

        delete this.user.vAlias;
        delete this.user.vPlate;
      }

      this.$auth
        .register({
          data: this.user,
          autoLogin: false,
          error(error) {
            const status = ((error || {}).response || {}).status;
            const message =
              (((error || {}).response || {}).data || {}).message ||
              this.$t('global.otpError.message');
            const data = ((error || {}).response || {}.data || {}.data || {})
              .data;

            this.user = userData;
            this.step = "data";

            // enable modal button
            this.$refs.modal.stopLoading();
            this.$refs.modal.close();

            if (status === 409) {
              this.$buefy.toast.open({
                message: this.$t('global.registerError.409'),
                type: "is-danger",
              });
            } else if (status === 426) {
              this.maskedPhoneNumber = (
                (data || {}).data || {}
              ).maskedPhoneNumber;
              this.$refs.otpValidation.checkStep(this.maskedPhoneNumber);
              this.$root.$emit("open-otp-validation-modal");
            } else {
              this.$buefy.toast.open({
                message,
                type: "is-danger",
              });
            }
          },
        })
        .then((res) => {
          // Auto login
          this.$auth.watch.authenticated = true;
          this.$auth.watch.loaded = true;
          this.$auth.user(res.data);
          document.cookie = "rememberMe=false";

          this.$router.push("/dashboard");
        });
    },

    documentMask() {
      return this.user.document &&
        this.user.document.replace(/[./-]/g, "").length > 11
        ? "##.###.###/####-##"
        : "###.###.###-##";
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/sass/variables";

.help {
  margin-top: -0.35rem;
  margin-bottom: 0.5rem;
}

.verify-password {
  li {
    color: $white;
    font-size: 0.9rem;
    line-height: 1.5rem;
    padding-left: 1.2rem;
    background: $tickIcon no-repeat center left;
  }

  li.is-valid {
    background-image: $tickPrimaryIcon;
  }
}

.verify-password-title {
  color: $white;
  margin-top: 1.5rem;
}
</style>
